import { render } from "./PriceModal.vue?vue&type=template&id=1fc4c94f&scoped=true"
import script from "./PriceModal.vue?vue&type=script&lang=js"
export * from "./PriceModal.vue?vue&type=script&lang=js"

import "./PriceModal.vue?vue&type=style&index=0&id=1fc4c94f&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc4c94f"]])

export default __exports__